export { default } from './RichTextInput';
